import { ThumbsDown, ThumbsUp } from '@phosphor-icons/react';
import { Feedback } from '../../common/types';
import useIsMobile from '../../hooks/use-is-mobile';
import { cn } from '../../lib/utils';
import { CURRENT_INSTANCE } from '../../tenant';

interface FeedbackPanelProps {
  submit: (feedback: Feedback) => void;
}

function FeedbackPanel(props: FeedbackPanelProps) {
  const isMobile = useIsMobile();
  const iconSize = isMobile ? 24 : 28;
  const chatClasses = CURRENT_INSTANCE.theme.classes?.chat;

  return (
    <div className="flex items-center gap-3">
      <ThumbsUp
        size={iconSize}
        className={cn(
          'cursor-pointer text-[hsl(var(--xircle-main))] hover:text-[hsl(var(--xircle-secondary))]'
        )}
        onClick={() => props.submit(Feedback.Like)}
      />
      <ThumbsDown
        size={iconSize}
        className={cn(
          'cursor-pointer text-[hsl(var(--xircle-main))] hover:text-[hsl(var(--xircle-secondary))]',
          chatClasses?.thumbsDown
        )}
        onClick={() => props.submit(Feedback.Dislike)}
      />
    </div>
  );
}

export default FeedbackPanel;
